/* eslint-disable max-len */
import Question from 'images/coin-pages/questions/inj.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const injPage: ICoinPageData = {
  title: 'coin_546',
  description: 'coin_547',
  // description: 'coin_548',
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Injective (INJ)' }) }}
    />
  ),
  questionsBlock: {
    image: Question,
    questions: [
      {
        title: 'coin_549',
        answer: 'coin_550',
      },
      {
        title: 'coin_551',
        answer: 'coin_552',
      },
      {
        title: 'coin_553',
        answer: 'coin_554',
      },
      {
        title: 'coin_555',
        answer: 'coin_556',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Injective (INJ)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_557',
        text: ['coin_559'],
      },
      {
        title: 'coin_558',
        text: ['coin_560'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-is-inj-and-how-to-use-it-to-gain-profit/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2023/05/Gain-profit-4.png',
        imageAlt: 'Hold INJ & Gain profit',
      },
      blogCards.borrowLikePro,
      blogCards.cryptoCrash,
    ],
  },
}
